<template>
  <v-dialog persistent width="800" v-model="dialog" scrollable>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot />
      </span>
    </template>
    <v-card :loading="loading">
      <v-card-title>
        Documentos de {{ tipoProprietario.descricao }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="selecao.id_proprietario"
          :items="items"
          label="Documentos de"
          item-value="id"
          :disabled="!this.mudarProprietario || loading"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-subtitle>{{ item.codigo }}</v-list-item-subtitle>
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:selection="{ item }">
            <v-list-item-content>
              <v-list-item-subtitle>{{ item.codigo }}</v-list-item-subtitle>
              <v-list-item-title>{{ item.titulo }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
        <template v-if="selecao.id_proprietario">
          <div class="d-flex align-center">
            <h3>Documentos</h3>
            <v-checkbox
              v-if="documentos.length > 0"
              v-model="selecionarTodos"
              indeterminate
              label="Selecionar todos"
              dense
              hide-details
              class="ml-4 my-0"
            />
          </div>
          <v-alert type="info" v-if="documentos.length === 0"
            >Não há documentos para este registro</v-alert
          >
          <v-list v-else>
            <v-list-item-group
              v-model="selecao.documentos_selecionados"
              multiple
            >
              <v-list-item
                v-for="(doc, i) in documentos"
                :key="`doc-${i}`"
                class="px-0"
                :value="doc.id"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action class="pl-5 mr-3">
                    <v-checkbox :input-value="active" />
                  </v-list-item-action>
                  <v-list-item-avatar color="grey lighten-2 mr-3">
                    <v-btn icon @click.stop="download(doc)">
                      <v-icon class="mdi mdi-download"></v-icon>
                    </v-btn>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="d-flex align-center">
                      <strong class="mr-1">{{
                        doc.tipo_documento.descricao
                      }}</strong>
                      {{ doc.registro }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <vencimento-documento :documento="doc" :icon="true" />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed @click="dialog = false">CANCELAR</v-btn>
        <v-btn
          depressed
          color="primary"
          @click="selecionar()"
          :disabled="!alterar"
        >
          <v-icon class="mr-2">mdi-check</v-icon>
          SELECIONAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { securedAxios } from "../../lib/axios";
import VencimentoDocumento from "./VencimentoDocumento";
import moment from "moment";
export default {
  components: { VencimentoDocumento },
  props: [
    "tipoProprietario",
    "idProprietario",
    "documentosSelecionados",
    "mudarProprietario",
    "alterar",
  ],
  data() {
    return {
      dialog: false,
      items: [],
      selecao: {
        id_proprietario: null,
        tipo_proprietario: null,
        proprietario: null,
        documentos_selecionados: [],
      },
      documentos: [],
      loading: false,
      selecionarTodos: null,
    };
  },
  async mounted() {
    if (this.mudarProprietario) {
      try {
        const response = await securedAxios.get(
          this.tipoProprietario.url_pesquisa,
          {}
        );
        this.items = response.data.map((i) => {
          return {
            codigo: i[this.tipoProprietario.campo_codigo] || "",
            titulo: i[this.tipoProprietario.campo_titulo] || "",
            id: i.id,
          };
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text:
            "Não foi possível carregar a lista de proprietários de documento",
        });
      }
    } else {
      this.selecao.id_proprietario = this.idProprietario;
      try {
        const url = this.tipoProprietario.url_detalhe.replace(
          "{id}",
          this.idProprietario
        );
        const response = await securedAxios.get(url);
        this.items.push({
          codigo: response.data[this.tipoProprietario.campo_codigo],
          titulo: response.data[this.tipoProprietario.campo_titulo],
          id: response.data.id,
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text:
            "Não foi possível carregar a lista de proprietários de documento",
        });
      }
    }
  },
  methods: {
    dataValidade(doc) {
      if (doc.data_validade === "") return "-";
      return moment(doc.data_validade).format("DD/MM/YYYY");
    },
    async download(doc) {
      try {
        const response = await this.$store.dispatch("documento/download", {
          urlBase: this.tipoProprietario.url_pesquisa.substr(1),
          doc,
        });
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (e) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível realizar o download do arquivo",
        });
      }
    },
    selecionar() {
      this.$emit("selecionar", this.selecao);
      this.dialog = false;
    },
  },
  watch: {
    async "selecao.id_proprietario"(id) {
      if (!id || id == "") {
        return;
      }
      this.loading = true;
      try {
        this.documentos = await this.$store.dispatch("documento/listar", {
          urlBase: this.tipoProprietario.url_pesquisa.substr(1),
          IDProprietario: id,
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de documentos",
        });
      }
      this.loading = false;
    },
    dialog() {
      this.selecao = {
        id_proprietario: this.idProprietario,
        tipo_proprietario: this.tipoProprietario,
        proprietario: null,
        documentos_selecionados: this.documentosSelecionados,
      };
    },
    selecionarTodos(val) {
      if (val) {
        this.selecao.documentos_selecionados = this.documentos.map((i) => i.id);
      } else {
        this.selecao.documentos_selecionados = [];
      }
    },
  },
};
</script>
